module.exports = __webpack_public_path__ + "static/img/A55_bg1.f3040a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/A55_bg1.jpg
// module id = d+Yv
// module chunks = 0